import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '../../../../material.module';

import { EmailSuggestOverlayComponent } from './email-suggest-overlay.component';
import { EmailSuggestDirective } from './email-suggest.directive';

@NgModule({
  declarations: [EmailSuggestDirective, EmailSuggestOverlayComponent],
  imports: [CommonModule, OverlayModule, MaterialModule],
  exports: [EmailSuggestDirective, EmailSuggestOverlayComponent],
})
export class EmailSuggestModule {}
